import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function minOneRequiredValidator(
  formControlNames: string[],
  groupKey: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    for (let index = 0; index < formControlNames.length; index++) {
      const abstractControl: AbstractControl | null = control.get(
        formControlNames[index]
      );
      if (abstractControl) {
        if (abstractControl.value) {
          return null;
        }
      }
    }
    return { ["minOneRequired" + `_${groupKey}`]: true };
  };
}
